import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Quick Access controller connected
  }

  open() {
    // Finde den Command Palette Controller und rufe dessen open() Methode auf
    const commandPaletteElement = document.querySelector('[data-controller*="command-palette"]')
    if (commandPaletteElement) {
      // Dispatch ein Event an den Command Palette Controller
      const event = new CustomEvent('quick-access:open')
      commandPaletteElement.dispatchEvent(event)
    }
  }
}
